module.exports = __webpack_public_path__ + "assets/img/Collected.fdbd1594.png";